module.exports = __webpack_public_path__ + "static/media/animated_ghanshyam.04dc5b27.png";